// extracted by mini-css-extract-plugin
export default {"centerContainer":"ScheduledLesson_centerContainer__+NJtI","header":"ScheduledLesson_header__mbXDJ"};